import { IChat, IContact, IRequest, IResponse, IHandlers, ChatEvents, IMessage, IConnectionArgs, ILoadPractitionerPatients, INewChat } from '@interfaces/chat/chatI';
import { io, Socket } from 'socket.io-client';
import { socketChat_url,socketChat_path } from '../../environments/socket-chat';

// const testSocket =  "http://localhost:5042";
let socket: Socket;

// This function is used to emit to the socket
function simpleSocketEmit<T>(request: IRequest, emit: string, functionName: string): Promise<IResponse<T>> {
    return new Promise((resolve, reject) => {
        try {
            socket.emit(emit, request, (data: IResponse<T>) => {
                resolve(data);
            });
        }
        catch (error) {
            console.error(functionName, error);
            reject(undefined);
        }
    });
}

/**
 * Function to init communication to the sockeIo server
 * @param sessionId Session ID if it exists
 * @param handlers Requests that will listen for changes in socket channels
 * @param args Connection data 
 */
export function initCommunication(sessionId: string, handlers: IHandlers, args: IConnectionArgs) 
{
    return new Promise((resolve, reject) => {
        try {
            socket = io(
                socketChat_url, // URL of the main connection
                {
                    path: socketChat_path, //socket server path
                    extraHeaders: {// These are optional data that we can share with the socket
                        sessionid: sessionId
                    },
                }
            );
            // This function is automatically issued by the socket when there is a connection
            socket.on("connect", () => {
                console.debug("Chat socket: connected");
                if(args.loginAvailable)
                {
                    handlers.onConnected(args.initial || false);
                    resolve(true);
                }
                else 
                    resolve(false);
            });

            // This function is automatically issued by the socket when the connection to the socket is lost.
            socket.on("disconnect", function() {
                console.warn("Chat socket: Disconnected");
            });

            // If handlers exist, they are sent to listen
            if(handlers)
                setHandlers(handlers);
        }
        catch (error) {
            console.error("initCommunication", error);
            reject(false);
        }
    });
}
// Function to listen when we receive a new chat
export function newChat(args: INewChat){
    if (socket && args.value) {
        const request: IRequest = {
            chatId: args.value
        }
        socket.emit("subscribe_to_chat_messages", request);  // A request is sent to listen to chat messages.
    }
}
export function finishCommunication(){
    socket?.disconnect();    
    socket?.close();    
    // eslint-disable-next-line
    (socket as any) = null
}

// Function to manage the listeners on the channels
export function setHandlers(handlers: IHandlers)
{
    if(!checkConnection()) return false;

    try
    {
        socket.on("inner_notify", newChat);
        socket.on(ChatEvents.CHAT_CHANGE, handlers.onChatChange);
        socket.on(ChatEvents.CONTACT_CHANGE, handlers.onContactChange);
        socket.on(ChatEvents.MESSAGE_CHANGE, handlers.onMessageChange);
        socket.on(ChatEvents.STATUS_CHANGE, handlers.onStatusChange);
        socket.on(ChatEvents.MESSAGE_UNREAD, handlers.onUnreadMessages)

        return true;
    }
    catch(error)
    {
        console.error("setHandlers", error);
        return false;
    }
}
// Function to check the current connection
export function checkConnection(checkConnected = true) {
    try {
        if (!socket) throw new Error("Socket connection is undefined");
        else if (checkConnected && !socket.connected) throw new Error("Socket connection is defined but is not connected to the chat host");
    }
    catch (error) {
        console.error("checkConnection", error);
    }
    return socket
}

// Functions that emit to the socket server

export function login(request: IRequest) {
    return simpleSocketEmit(request, "login", "login") as Promise<IResponse<boolean>>
}
export function logout(request: IRequest){
    return simpleSocketEmit(request, "logout", "logout") as Promise<IResponse<boolean>>
}
export function getPatientContactsList(request: ILoadPractitionerPatients) {
    return simpleSocketEmit(request, "get_contact_patients_list", "getContactList") as Promise<IResponse<IContact[]>>
}
export function getChat(request: IRequest) {
    return simpleSocketEmit(request, "load_chat", "getChat") as Promise<IResponse<IChat>>
}
export function getChatMessages(request: IRequest) {
    return simpleSocketEmit(request, "load_chat_messages", "getChatMessages") as Promise<IResponse<IMessage[]>>
}
export function sendMessageToChat(request: IRequest) {
    return simpleSocketEmit(request, "send_message", "sendMessageToChat") as Promise<IResponse<IContact[]>>
}
export function markMessageAsRead(request: IRequest){
    return simpleSocketEmit(request, "mark_message_as_read", "messageMarkAsRead") as Promise<IResponse<boolean>>
}
export function createChat(request: IRequest) {
    return simpleSocketEmit(request, "create_chat", "createChat") as Promise<IResponse<IChat>>
}